export enum DisplayType {
	Success = 'Success',
	Information = 'Information',
	Warning = 'Warning',
	Error = 'Error',
}
